import React from 'react';

// Material UI
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import FilterListIcon from '@mui/icons-material/FilterList';

// Components
import Dropdown from "../../../components/inputs/dropdown";

import WrapperDatePicker from '../../../components/wrapperDatapicker';
import { cashTypesSelect } from "../../../models/CashRegisterMovementEntity";

import useStyles from "./styles";
import Searchbox from '../../../components/inputs/searchbox';

const Filters = ({ filters, onFilterChange, cashRegisters, clearFilters }) => {
    const { classes } = useStyles();

    return (
        <Paper className={classes.paper} style={{ marginTop: '20px' }}>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Seleccionar caja: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Dropdown
                                fullWidth
                                name='cashRegisterId'
                                label='Caja'
                                onChange={onFilterChange}
                                size='small'
                                getOptionLabel={(option) => `${option?.name}`}
                                getOptionValue={(option) => option?.id}
                                values={cashRegisters}
                                value={filters?.cashRegisterId || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        md: 6
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por fecha: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >

                            <WrapperDatePicker
                                filters={filters?.from}
                                handleFilterChange={onFilterChange}
                                type="from"
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >


                            <WrapperDatePicker
                                filters={filters?.to}
                                handleFilterChange={onFilterChange}
                                type="to"
                            />
                        </Grid>

                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Seleccionar Usuario: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Searchbox
                                fullWidth
                                size='small'
                                name='user'
                                label="Email"
                                onChange={onFilterChange}
                                value={filters?.user || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Seleccionar Origen: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Dropdown
                                fullWidth
                                size='small'
                                name='cashTypeOrigin'
                                label='Medio de pago'
                                onChange={onFilterChange}
                                value={filters?.cashTypeOrigin || ''}
                                values={cashTypesSelect}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Seleccionar Destino: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Dropdown
                                fullWidth
                                size='small'
                                name='cashTypeDestination'
                                label='Medio de pago'
                                onChange={onFilterChange}
                                value={filters?.cashTypeDestination || ''}
                                values={cashTypesSelect}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Numero de Factura: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Searchbox
                                fullWidth
                                size='small'
                                name='invoiceNumber'
                                label="Numaro de Factura"
                                onChange={onFilterChange}
                                value={filters?.invoiceNumber || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    className={classes.rootFab}
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 3
                    }}
                >
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={clearFilters}
                        className={classes.button}
                        startIcon={<FilterListIcon />}
                    >
                        Limpiar
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default Filters;